let view = /*html*/`
<div class="d-flex flex-column flex-column-fluid">
<!--begin::Content-->
<div class="d-flex flex-column flex-column-fluid text-center p-10 py-lg-15">
    <!--begin::Logo-->
    <a href="./" class="mb-5 pt-lg-10">
        <h1 class="text-white text-center fs-2tx">pDx<span class="text-warning">PLAY</span></h1>
    </a>
    <!--end::Logo-->
    <!--begin::Wrapper-->
    <div class="mb-10">
        <!--begin::Illustration-->
        <div class="d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-200px min-h-lg-350px" style="background-image: url(assets/media/landing/landing_render2.png"></div>
        <!--end::Illustration-->
        <!--begin::Logo-->
        <h1 class="fw-bolder fs-2qx text-gray-800 mb-10" data-i18n="wrong.system">System Error</h1>
        <!--end::Logo-->
        <!--begin::Message-->
        <div class="fw-bold fs-3 text-muted mb-15" data-i18n="[html]wrong.some">Something went wrong! 
        <br>Please try again later.</div>
        <!--end::Message-->
        <!--begin::Action-->
        <div class="text-center">
            <a href="" data-navigo class="btn btn-lg btn-outline btn-outline-primary fw-bolder" data-i18n="wrong.home">Go to homepage</a>
        </div>
        <!--end::Action-->
    </div>
    <!--end::Wrapper-->
    
</div>
<!--end::Content-->
<!--begin::Footer-->
<div class="d-flex flex-center flex-column-auto p-10">
    <!--begin::Links-->
    <div class="d-flex align-items-center fw-bold fs-6">
        <a href="site/about" class="text-muted text-hover-primary px-2" data-i18n="wrong.about">About</a>
        <a href="mailto:gungamer@paradoxteam.org" class="text-muted text-hover-primary px-2" data-i18n="wrong.contact">Contact</a>
        <a href="https://discord.io/pDxPLAY" class="text-muted text-hover-primary px-2" data-i18n="wrong.discord">Discord</a>
    </div>
    <!--end::Links-->
</div>
<!--end::Footer-->
</div>`;

export default view;